import axios from "axios";
import React, { Component } from "react";
import FeatherIcon from "feather-icons-react";
import Modal from "react-bootstrap/Modal";
import Select from "react-select";
import { toast } from "react-toastify";

class LeaveForm extends Component {
  state = {
    id: "",
    reason: "",
    date_start: "",
    date_end: "",
    staffId: "",
    staffs: [],
    title: "",
    error: "",
    loadingStaffs: false,
    saving: false,
  };

  handleInput = (event) => {
    this.setState({ [event.target.name]: event.target.value, error: "" });
  };

  formatInputDate = (value) => {
    if (!value) return "";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "";

    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${date.getFullYear()}-${month}-${day}`;
  };

  getDuration = () => {
    if (!this.state.date_start || !this.state.date_end) return 0;
    const start = new Date(`${this.state.date_start}T00:00:00`);
    const end = new Date(`${this.state.date_end}T00:00:00`);
    if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime()) || end < start) {
      return 0;
    }
    return Math.floor((end - start) / 86400000) + 1;
  };

  validate = () => {
    if (!this.state.staffId) return "Sélectionnez un membre du personnel.";
    if (!this.state.reason.trim()) return "Renseignez le motif du congé.";
    if (!this.state.date_start || !this.state.date_end) {
      return "Renseignez les dates de début et de fin.";
    }
    if (new Date(this.state.date_end) < new Date(this.state.date_start)) {
      return "La date de fin doit être postérieure ou égale à la date de début.";
    }
    return "";
  };

  storeLeave = async () => {
    const validationError = this.validate();
    if (validationError) {
      this.setState({ error: validationError });
      return;
    }

    const data = {
      staffId: this.state.staffId,
      reason: this.state.reason.trim(),
      date_start: this.state.date_start,
      date_end: this.state.date_end,
    };

    this.setState({ saving: true, error: "" });

    try {
      const response = this.state.id
        ? await axios.put(`leaves/${this.state.id}`, data)
        : await axios.post("leaves", data);

      toast.success(response?.data?.msg || "Le congé a été enregistré.");
      this.props.showModal();
    } catch (error) {
      const message =
        error.response?.data?.msg || "L’enregistrement du congé a échoué.";
      this.setState({ error: message });
      toast.error(message);
    } finally {
      this.setState({ saving: false });
    }
  };

  getStaffs = async () => {
    this.setState({ loadingStaffs: true });

    try {
      const response = await axios.get("staffs");
      const staffs = Array.isArray(response.data) ? response.data : [];

      this.setState({
        staffs: staffs.map((staff) => {
          const user = staff.user || {};
          const name = [user.last_name, user.family_name, user.first_name]
            .filter(Boolean)
            .join(" ");

          return {
            value: staff.id,
            label: `${staff.matricule || "Sans matricule"} — ${
              name || "Personnel sans nom"
            }`,
          };
        }),
      });
    } catch (error) {
      this.setState({
        staffs: [],
        error: "Impossible de charger la liste du personnel.",
      });
    } finally {
      this.setState({ loadingStaffs: false });
    }
  };

  edit = () => {
    this.form();
    this.getStaffs();
  };

  form = () => {
    const data = this.props.formData;

    this.setState({
      id: data?.id || "",
      reason: data?.reason || "",
      date_start: this.formatInputDate(data?.date_start),
      date_end: this.formatInputDate(data?.date_end),
      staffId: data?.staff?.id || "",
      title: data ? "Modifier le congé" : "Ajouter un congé",
      error: "",
      saving: false,
    });
  };

  render() {
    const selectedStaff =
      this.state.staffs.find(
        (option) => String(option.value) === String(this.state.staffId)
      ) || null;
    const duration = this.getDuration();

    return (
      <Modal
        show={this.props.isModal}
        onHide={this.props.showModal}
        size="lg"
        dialogClassName="ev-form-dialog leave-form-dialog"
        contentClassName="ev-form-modal ev-form-modal--compact leave-form-modal"
        onEntered={this.edit}
        backdrop="static"
      >
        <Modal.Header>
          <div className="ev-form-heading">
            <span className="ev-form-heading__icon">
              <FeatherIcon icon="calendar" size={20} />
            </span>
            <div>
              <span className="ev-form-heading__eyebrow">Planning des absences</span>
              <Modal.Title>{this.state.title}</Modal.Title>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body className="row ev-form-body leave-form__body">
          {this.state.error && (
            <div className="col-12">
              <div className="ev-form-alert" role="alert">
                <FeatherIcon icon="alert-circle" size={17} />
                <span>{this.state.error}</span>
              </div>
            </div>
          )}

          <div className="col-12 ev-form-section">
            <span><FeatherIcon icon="user" size={16} /></span>
            <div>
              <strong>Personnel concerné</strong>
              <small>Choisissez la personne qui prendra ce congé</small>
            </div>
          </div>

          <div className="col-12 mt-2">
            <label>
              Personnel <span className="text-danger">*</span>
            </label>
            <Select
              className="form-control form-control-sm p-0"
              value={selectedStaff}
              onChange={(option) =>
                this.setState({ staffId: option?.value || "", error: "" })
              }
              options={this.state.staffs}
              isLoading={this.state.loadingStaffs}
              isClearable
              placeholder="Rechercher par nom ou matricule…"
              noOptionsMessage={() => "Aucun personnel disponible"}
            />
          </div>

          <div className="col-12 ev-form-section">
            <span><FeatherIcon icon="calendar" size={16} /></span>
            <div>
              <strong>Période et motif</strong>
              <small>Précisez les dates ainsi que la raison de l’absence</small>
            </div>
          </div>

          <div className="col-md-7 mt-2">
            <label htmlFor="leave-reason">
              Motif du congé <span className="text-danger">*</span>
            </label>
            <textarea
              id="leave-reason"
              className="form-control leave-form__reason"
              rows={5}
              name="reason"
              value={this.state.reason}
              onChange={this.handleInput}
              placeholder="Ex. congé annuel, raison familiale…"
            />
          </div>

          <div className="col-md-5 mt-2">
            <div className="leave-form__dates">
              <div className="form-group has-icon-left">
                <label htmlFor="leave-date-start">
                  Date de début <span className="text-danger">*</span>
                </label>
                <div className="position-relative">
                  <input
                    id="leave-date-start"
                    type="date"
                    className="form-control"
                    name="date_start"
                    value={this.state.date_start}
                    onChange={this.handleInput}
                  />
                  <div className="form-control-icon">
                    <FeatherIcon icon="log-in" />
                  </div>
                </div>
              </div>

              <div className="form-group has-icon-left">
                <label htmlFor="leave-date-end">
                  Date de fin <span className="text-danger">*</span>
                </label>
                <div className="position-relative">
                  <input
                    id="leave-date-end"
                    type="date"
                    className="form-control"
                    name="date_end"
                    min={this.state.date_start || undefined}
                    value={this.state.date_end}
                    onChange={this.handleInput}
                  />
                  <div className="form-control-icon">
                    <FeatherIcon icon="log-out" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-12">
            <div className="leave-form__summary">
              <span><FeatherIcon icon="clock" size={16} /></span>
              <div>
                <small>Durée calculée</small>
                <strong>
                  {duration
                    ? `${duration} ${duration > 1 ? "jours" : "jour"}`
                    : "Sélectionnez une période valide"}
                </strong>
              </div>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <span className="ev-form-footer-note">
            <FeatherIcon icon="info" size={14} />
            Les champs marqués d’un * sont obligatoires
          </span>
          <button
            type="button"
            onClick={this.props.showModal}
            disabled={this.state.saving}
            className="btn btn-light ev-form-button"
          >
            <FeatherIcon icon="x" size={16} />
            Fermer
          </button>
          <button
            type="button"
            onClick={this.storeLeave}
            disabled={this.state.saving || this.state.loadingStaffs}
            className="btn btn-primary ev-form-button"
          >
            <FeatherIcon icon={this.state.saving ? "loader" : "check"} size={16} />
            {this.state.saving ? "Enregistrement…" : "Sauvegarder"}
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default LeaveForm;
